import React, { useState } from "react";
import ButtonSecondary from "../buttons/ButtonSecondary";
import Cookies from "js-cookie";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useParams } from "react-router-dom";
import useFileManagerApi from "../../hooks/api/useFileManagerApi";

const ModalCreateFolder = ({ isOpen, onClose, selectedFolder, onFolderCreated, currentPath = "" }) => {
  const [folderName, setFolderName] = useState("");
  const [folderCreated, setFolderCreated] = useState(false);
  const { folderNameParam } = useParams();
  const { createFolder, fetchFolderStructure } = useFileManagerApi();

  const handleInputChange = (e) => {
    setFolderName(e.target.value);
  };
  const handleCreateFolder = async () => {
    const accessToken = Cookies.get("AccessToken");
    const newFolderName = folderName.trim();
    if (!newFolderName) {
      toast.error("Folder name is required.");
      return;
    }

    let parentPath = "";

    if (typeof selectedFolder === "string" && selectedFolder.trim() !== "") {
      parentPath = selectedFolder.trim();
    } else if (Array.isArray(selectedFolder) && selectedFolder.length > 0) {
      const firstSelected = selectedFolder[0];
      if (typeof firstSelected === "string" && firstSelected.trim() !== "") {
        parentPath = firstSelected.trim();
      } else if (firstSelected && typeof firstSelected === "object") {
        const candidatePath =
          firstSelected.path ||
          firstSelected.fullPath ||
          firstSelected.id ||
          firstSelected.name ||
          "";
        parentPath = candidatePath;
      }
    }

    if (!parentPath && typeof currentPath === "string" && currentPath.trim() !== "") {
      parentPath = currentPath.trim();
    }

    if (!parentPath && folderNameParam) {
      parentPath = folderNameParam;
    }

    const sanitizedParentPath = parentPath
      ? parentPath.replace(/^\/+/, "").replace(/\/+$/, "")
      : "";

    const cleanedParentSegments = sanitizedParentPath
      ? sanitizedParentPath.split("/").filter(Boolean)
      : [];

    const cleanedFolderName = newFolderName.replace(/^\/+/, "").replace(/\/+$/, "");

    // Build pathToFolder: include parent path + new folder name
    // If in root: /newFolderName
    // If in folder: /parentPath/newFolderName
    const parentSegments = cleanedParentSegments.filter(Boolean);
    const pathToFolder =
      parentSegments.length > 0 ? `/${parentSegments.join("/")}` : "/";
    try {
      if (!accessToken) {
        toast.error("Authentication required. Please log in.");
        return;
      }

      await createFolder({
        folderName: cleanedFolderName,
        pathToFolder,
      });

      toast.success("Folder created successfully");

      try {
        if (onFolderCreated) {
          await onFolderCreated();
        } else {
          await fetchFolderStructure();
        }
      } catch (refreshError) {
        console.error("Error refreshing folder structure:", refreshError);
      }

      setFolderCreated(true);

      setTimeout(() => {
        setFolderCreated(false);
        setFolderName("");
        if (onClose) {
          onClose();
        }
      }, 1500);
    } catch (error) {
      toast.error("Error creating folder:", error);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <div className="fixed top-0 left-0 w-full h-full bg-gray-500 bg-opacity-75 flex justify-center items-center z-50">
        <div
          className={`${folderCreated ? "bg-greenLight" : "bg-white"} p-8 rounded-lg mx-6`}
        >
          {folderCreated ? (
            <div>
              <p className="text-bodyMR text-dark4 mb-4 text-left">
                <span className="text-bodyMS text-greenDark">{folderName} </span>
                has been created with success
              </p>
            </div>
          ) : (
            <div>
              <h2 className="text-h6 text-dark4 mb-4 text-left">
                Create a folder
              </h2>
              <label
                htmlFor="folderName"
                className="text-bodyLR text-dark4 text-left"
              >
                Name
              </label>
              <input
                type="text"
                id="folderName"
                className="border-gray-300 border p-2 w-full rounded mt-2"
                value={folderName}
                onChange={handleInputChange}
              />
              <div className="flex justify-center mt-4 space-x-6">
                <ButtonSecondary
                  text="Create"
                  customClass="bg-primary text-white text-bodyMR p-1 px-[22px] py-[6px]"
                  onClick={handleCreateFolder}
                />
                <ButtonSecondary
                  text="Cancel"
                  customClass="bg-white text-dark4 text-bodyMR border border-dark4 px-[22px] py-[6px]"
                  onClick={handleCancel}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={7000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

export default ModalCreateFolder;
